import React from 'react';
import { IconSvgProps } from '@models/common';

const GRADIENT_ID = 'icon-infinity-gradient';

const InfinitySign: React.FC<IconSvgProps> = (props) => {
  const { size = 16, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.9375 4.25C10.6603 4.25 9.64187 4.89156 9.0125 5.43L8.99031 5.44906L8.63188 5.83875L9.42313 7.13906L10.0087 6.55188C10.6216 6.03438 11.3056 5.75 11.9375 5.75C13.2125 5.75 14.25 6.75938 14.25 8C14.25 9.24062 13.2125 10.25 11.9375 10.25C10 10.25 8.68313 7.68906 8.67 7.66313C8.59375 7.50906 6.92375 4.25 4.0625 4.25C1.96031 4.25 0.25 5.93219 0.25 8C0.25 10.0678 1.96031 11.75 4.0625 11.75C5.09219 11.75 6.10562 11.3403 6.99344 10.565L7.0125 10.5481L7.36812 10.1613L6.57656 8.86094L5.98812 9.45094C5.375 9.98125 4.72687 10.25 4.0625 10.25C2.7875 10.25 1.75 9.24062 1.75 8C1.75 6.75938 2.7875 5.75 4.0625 5.75C6 5.75 7.31687 8.31094 7.33 8.33687C7.40625 8.49094 9.07625 11.75 11.9375 11.75C14.0397 11.75 15.75 10.0678 15.75 8C15.75 5.93219 14.0397 4.25 11.9375 4.25Z'
        fill={`url(#${GRADIENT_ID})`}
      />
      <defs>
        <linearGradient
          id={GRADIENT_ID}
          x1='0.25'
          y1='7.92647'
          x2='15.75'
          y2='7.92647'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#4730EE' />
          <stop
            offset='0.348958'
            stopColor='#724FFB'
          />
          <stop
            offset='0.692708'
            stopColor='#B879C4'
          />
          <stop
            offset='1'
            stopColor='#EF8278'
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default InfinitySign;
